<div class="tool-bar">
  <input pInputText BlockLateralArrowNavigation type="tel" class="area-name-input-text"
         [(ngModel)]="area.name" (keyup)="nameUpdate()">

  <div class="sum-label">Cells Sum: {{sumValue | number: '1.2-2'}} Qty: {{sumValueQty}}</div>
</div>
<div class="table-middle">

  <div class="left-block" *ngIf="switchAreaLoading">
    <lib-progress-spinner></lib-progress-spinner>
  </div>

  <div class="left-block" *ngIf="!switchAreaLoading">
    <app-settings-table-sheet [area]="area" [pricingId]="pricingId"></app-settings-table-sheet>

    <app-subtotals-table-sheet [area]="area" [pricingId]="pricingId"></app-subtotals-table-sheet>

    <app-breakdown-table-sheet [area]="area" [pricingId]="pricingId"></app-breakdown-table-sheet>

    <app-formulas-table-sheet [area]="area" [pricingId]="pricingId"></app-formulas-table-sheet>
  </div>


  <div class="sheets-block another-left" *ngIf="!switchAreaLoading">
    <app-table-sheet *ngFor="let group of miscAndAddonsGroups" [pricingName]="group.name"
                     [pricingGroup]="group"
                     [area]="area"
                     [pricingId]="pricingId" [typeOfSheet]="'Default'"></app-table-sheet>
  </div>

  <div class="sheets-block another-left" *ngIf="switchAreaLoading">
    <lib-progress-spinner></lib-progress-spinner>
  </div>

  <div class="sheets-block right-block" *ngIf="!switchAreaLoading">
    <app-table-sheet *ngFor="let group of groupsWithoutAddons" [pricingName]="group.name"
                     [pricingGroup]="group"
                     [area]="area"
                     [pricingId]="pricingId" [typeOfSheet]="'Default'"></app-table-sheet>
  </div>
  <div class="sheets-block" *ngIf="switchAreaLoading">
    <lib-progress-spinner></lib-progress-spinner>
  </div>
</div>
